<template>
    <div class="row center">
        <div class="col-9 col-md-13 col-xs-16">
            <p>{{ intro }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['intro']
}
</script>

<style>

</style>